module.exports = __webpack_public_path__ + "media/images/b2b_admin/login-0b67ca801823a840d3ad7705f660681c.svg";